import React, { useState, useEffect } from "react";
import { Menu, Loader2, ExternalLink } from "lucide-react";
import ProfileDropdown from "../Common/ProfileDropdown";

const AdminTopbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const name = localStorage.getItem("eventManagementAUserName");
        const img = localStorage.getItem("eventManagementAUserImage");
        setUserData({ fullName: name || "Admin", avatar: img || "" });
      } catch (error) {
        console.error("Gagal memuat profil", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUser();
  }, []);

  return (
    /* Tinggi ditingkatkan ke h-24 */
    <header className="h-24 bg-white border-b border-stone-200 flex items-center justify-between px-4 md:px-6 sticky top-0 z-40 font-sans">
      <div className="flex items-center gap-6">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="p-2.5 hover:bg-stone-100 rounded-xl text-stone-600 lg:hidden active:scale-90"
        >
          <Menu size={24} />
        </button>

        <a
          href="/"
          target="_blank"
          rel="noreferrer"
          className="group relative flex items-center gap-3 px-5 py-2.5 bg-white border border-stone-200 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 active:scale-95"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
          </span>
          <div className="flex items-center gap-2">
            <span className="text-[11px] font-black uppercase tracking-[0.2em] text-stone-500 group-hover:text-slate-900 transition-colors">
              Live Preview
            </span>
            <ExternalLink size={13} strokeWidth={2.5} className="text-stone-400 group-hover:text-amber-500" />
          </div>
        </a>
      </div>

      <div className="flex items-center gap-3 border-l border-stone-100 pl-4 h-12">
        {isLoading ? (
          <Loader2 size={16} className="animate-spin text-stone-300" />
        ) : (
          <ProfileDropdown 
            userName={userData?.fullName}
            imgUrl={userData?.avatar}
            handleLogout={handleLogout}
          />
        )}
      </div>
    </header>
  );
};

export default AdminTopbar;